import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref,onMounted,nextTick} from 'vue';
import sha1 from 'sha1';
import { showConfirmDialog } from 'vant';
import  axios from 'axios'
import weChatApi from "@/utils/Api/WeChat";
import commMethods from "@/assets/ts/common";
import store from "@/store";
import CONFIG from "../public/serverConfig";

// let data={
//   appid:'wxf7f8feac463160c9',
//   // appid:'wx23e0b50a33848bd9',
//   // appsecret:'1c069f7bd210697c1c89c2340523faa8',
//   scope:'snsapi_userinfo',//应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
//   timestamp:new Date().getTime(),
//   nonceStr:'Wm3WZYTPz0wzccnW'
// }

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const code:any=ref();

onMounted(()=>{

  let local = window.location.href;
  console.log('local',local)
  if(!commMethods.getStorage('code')){

    const searchParams = new URLSearchParams(window.location.search);
    if(searchParams.get('code'))
    commMethods.setStorage('code',searchParams.get('code'))
  }

  if(commMethods.getStorage('code')){
    console.log('zzzzinfo',commMethods.getStorage('info'))
    //请求后台获取token
    if(!commMethods.getStorage('info')){
      getToken();
    }else{
      store.state.refreshInfo=true;
    }
  }else{
    window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+CONFIG.appid+'&redirect_uri='+encodeURIComponent(local)+'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
  }
  // getTicket();
})

const getToken=()=>{
  weChatApi.getAccessTokenCode(commMethods.getStorage('code')).then(res=>{
    console.log('token',res)
    commMethods.setStorage('info',res.data);
    store.state.refreshInfo=true;
    // getUserInfo();
    // getTicket();
  }).catch(err=>{
    console.log(err)
    showConfirmDialog({
      title: '重新登录',
      message:'登录已过期，请重新登录',
    }).then(() => {
          // on confirm
     commMethods.relogin();
        }).catch(() => {
          // on cancel
        });
  })
}
// const getUserInfo=()=>{
//   let d=commMethods.getStorage('info');
//   // axios.get('/wx/sns/userinfo?access_token='+d.access_token+'&openid='+d.openid+'&lang=zh_CN').then(res=>{
//   //   console.log('信息',res)
//   //   createWeChatUser(res.data);
//   // })
//   axios.get('https://api.weixin.qq.com/sns/userinfo?access_token='+d.access_token+'&openid='+d.openid+'&lang=zh_CN').then(res=>{
//     console.log('信息',res)
//     createWeChatUser(res.data);
//   })
// }
// //创建微信用户
// const createWeChatUser=(data:any)=>{
//   weChatApi.createWeChatUser({
//     ...data,
//     headimg:data.headimgurl
//   }).then(res=>{
//     console.log('新增信息',res)
//     store.state.refreshInfo=true;
//   })
// }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})